<script lang="ts">
	import BuyCampfireLink from "@components/BuyCampfireLink.svelte";
	import Feature from "@components/Feature.svelte";
	import dotbackground from "@core/assets/icons/background-dot-small.svg?raw";
	import factory from "@core/assets/icons/factory.svg?raw";
	import soap from "@core/assets/icons/soap.svg?raw";
	import timer from "@core/assets/icons/timer.svg?raw";
	import verified from "@core/assets/icons/verified_user.svg?raw";
</script>

<section>
	<div class="grid lg:grid-cols-4 2xl:grid-cols-5 md:grid-cols-3 grid-cols-2 gap-2 lg:gap-6 mx-auto">
		<Feature icon={timer} label="Za 1 minutu nl[[]] složené i rozložené" />
		<Feature icon={factory} label="Vyrobeno v ČR z kotlářského plechu" />
		<Feature icon={soap} label="Čistý provoz nl[[]] a velmi rychlý úklid" />
		<Feature icon={dotbackground} label="Spodní miska zachytí všechen popel" />
		<Feature icon={verified} label="Pro transport je uzavřeno v plechové krabici" />
	</div>

	<BuyCampfireLink class="mx-auto mt-4 lg:mt-10" />
</section>
